import React from 'react';

interface Props {
  homeinspectionNegotiationDays?: number;
}

const GeneralInspection = ({ homeinspectionNegotiationDays }: Props) => {
  return (
    <>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          The Contingency Period is {homeinspectionNegotiationDays} days from
          the execution date of this agreement for Buyer's Due Diligence.
        </li>
        <li>
          Within the stated Contingency Period and as the result of any
          Inspection elected in this agreement:
        </li>
        <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
          <li>
            If the results of the inspections elected are satisfactory to Buyer,
            Buyer will present all Report(s) in their entirety to Seller, accept
            the Property with the information stated in the Report(s) and agree
            to the Release clause of this Agreement, OR
          </li>
          <li>
            If the results of any inspection elected are unsatisfactory to
            Buyer, Buyer will present all Report(s) in their entirety to Seller
            and terminate this Agreement by written notice to Seller, with all
            deposit monies returned to Buyer according to the terms of this
            Agreement, OR
          </li>
          <li>
            If the results of any inspection elected are unsatisfactory to
            Buyer, Buyer will present all Report(s) in their entirety to Seller
            with a Written Corrective Proposal (“Proposal”) listing corrections
            and/or credits desired by Buyer.
          </li>
          <li>
            The Proposal may, but is not required to, include the name(s) of a
            properly licensed or qualified professional(s) to perform the
            corrections requested in the Proposal, provisions for payment,
            including retests, and a projected date for completion of the
            corrections. Buyer agrees that Seller will not be held liable for
            corrections that do not comply with mortgage lender or governmental
            requirements if performed in a workmanlike manner according to the
            terms of Buyer’s Proposal.
          </li>
          <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>
              Following the end of the Contingency Period, Buyer and Seller will
              have {homeinspectionNegotiationDays} days for a Negotiation
              Period. During the Negotiation Period:
            </li>
            <li>
              Seller will acknowledge in writing Seller’s agreement to satisfy
              all the terms of Buyer’s Proposal OR
            </li>
            <li>
              Buyer and Seller will negotiate another mutually acceptable
              written agreement, providing for any repairs or improvements to
              the Property and/or any credit to Buyer at settlement, as
              acceptable to the mortgage lender, if any.
            </li>
          </ol>
          <li>
            If Seller agrees to satisfy all the terms of Buyer’s Proposal, or
            Buyer and Seller enter into another mutually acceptable written
            agreement, Buyer accepts the Property and agrees to the Release
            clause of this Agreement and the Negotiation Period ends.
          </li>
        </ol>
        <li>
          If no mutually acceptable written agreement is reached, or if Seller
          fails to respond during the Negotiation Period, within{' '}
          {homeinspectionNegotiationDays} days following the end of the
          Negotiation Period, Buyer will:
        </li>
        <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
          <li>
            Accept the Property with the information stated in the Report(s) and
            agree to the Release clause of this Agreement, OR
          </li>
          <li>
            Terminate this Agreement by written notice to Seller, with all
            deposit monies returned to Buyer according to the Release clause of
            this Agreement.
          </li>
          <li>
            If Buyer and Seller do not reach a mutually acceptable written
            agreement, and Buyer does not terminate this Agreement by written
            notice to Seller within {homeinspectionNegotiationDays} days, Buyer
            will accept the Property and agree to the Release clause of this
            Agreement. Ongoing negotiations do not automatically extend the
            Negotiation Period.
          </li>
        </ol>
        <li>
          If a Report reveals the need to expand or replace the existing
          individual on-lot sewage disposal system, Seller may, within{' '}
          {homeinspectionNegotiationDays} days of receiving the Report, submit a
          Proposal to Buyer. The Proposal will include, but not be limited to,
          the name of the company to perform the expansion or replacement;
          provisions for payment, including retests; and a projected completion
          date for corrective measures. Within {homeinspectionNegotiationDays}{' '}
          days of receiving Seller’s Proposal, or if no Proposal is provided
          within the stated time, Buyer will notify Seller in writing of Buyer’s
          choice to:
        </li>
        <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
          <li>
            Agree to the terms of the Proposal, accept the Property and agree to
            the Release clause of this Agreement, OR
          </li>
          <li>
            Terminate this Agreement by written notice to Seller, with all
            deposit monies returned to Buyer according to the terms of this
            Agreement, OR
          </li>
          <li>
            Accept the Property and the existing system and agree to the Release
            clause of this Agreement. If required by any mortgage lender and/or
            any governmental authority, Buyer will correct the defects before
            settlement or within the time required by the mortgage lender and/or
            governmental authority, at Buyer’s sole expense, with permission and
            access to the Property given by Seller, which may not be
            unreasonably withheld. If Seller denies Buyer permission and/or
            access to correct the defects, Buyer may terminate this Agreement by
            written notice to Seller, with all deposit monies returned to Buyer
            according to the terms of this Agreement.
          </li>
        </ol>

        <li>
          If Buyer fails to respond within {homeinspectionNegotiationDays} days
          after receipt of any elected Inspection Report or fails to terminate
          this Agreement by written notice to Seller within that time, Buyer
          will accept the Property and agree to the Release clause of this
          Agreement.
        </li>
      </ol>
    </>
  );
};

export default GeneralInspection;
